import React from "react";
import "./loader.css";

const Loader = () => {
  return <div id="loading" className="self-center mb-3" />;
};

export default Loader;
